import clsx from 'clsx';
import { shortId } from '../../db/ids.js';
import Button from '../../components/Button.jsx';
import Icon from '../../components/Icon.jsx';
import { haptic } from '../../app/settingsStore.js';
import styles from './NoteForm.module.scss';

export function emptyChoices() {
  return [
    { id: shortId(), text: '', correct: true },
    { id: shortId(), text: '', correct: false },
    { id: shortId(), text: '', correct: false },
  ];
}

export default function ChoicesEditor({ value, onChange }) {
  const choices = Array.isArray(value) && value.length ? value : emptyChoices();
  const update = (id, patch) => onChange(choices.map((c) => (c.id === id ? { ...c, ...patch } : c)));
  return (
    <div className={styles.choices}>
      {choices.map((c, i) => (
        <div key={c.id} className={clsx(styles.choice, c.correct && styles.choiceRight)}>
          <button
            type="button"
            role="checkbox"
            aria-checked={!!c.correct}
            aria-label={`Option ${i + 1} is correct`}
            className={styles.correct}
            onClick={() => {
              haptic(5);
              update(c.id, { correct: !c.correct });
            }}
          >
            <Icon name="check" size={18} stroke={3} />
          </button>
          <input
            className={styles.choiceInput}
            value={c.text}
            placeholder={`Option ${i + 1}`}
            onChange={(e) => update(c.id, { text: e.target.value })}
            aria-label={`Option ${i + 1}`}
            enterKeyHint="next"
          />
          <button
            type="button"
            className={styles.removeChoice}
            onClick={() => onChange(choices.filter((x) => x.id !== c.id))}
            disabled={choices.length <= 2}
            aria-label={`Remove option ${i + 1}`}
          >
            <Icon name="close" size={18} />
          </button>
        </div>
      ))}
      <Button icon="plus" onClick={() => onChange([...choices, { id: shortId(), text: '', correct: false }])}>
        Add option
      </Button>
    </div>
  );
}
